
// import { useLocation, Navigate } from "react-router-dom";
// import { MainLayout } from "../../App";
// import { AnimatedPageWrapper } from "./AnimatedPageWrapper";
// import { LoadingScreen } from "../loading-screen";
// import { useAuth } from "../../provider/useAuth";
// import NotFoundPage from "../NotFoundPage";


// const authPaths = ["/", "/login", "/register", "/forgot-password", "/password-reset/:token"];

// export default function RouteWrapper({
//   children,
//   protectedRoute = false,
//   publicRoute = false,
//   withMainLayout = false,
//   allowedRoles = [],
// }) {
//   const { isAuthenticated, isLoading } = useAuth();
//   const location = useLocation();
//   const userRole = sessionStorage.getItem("role")?.toLowerCase();

//   const isAuthRoute = authPaths.some((path) =>
//     new RegExp("^" + path.replace(/:\w+/g, "[^/]+") + "$").test(location.pathname)
//   );

//   if (isLoading) {
//     return <LoadingScreen />;
//   }

//   if (protectedRoute && !isAuthenticated) {
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }

//   if (publicRoute && isAuthenticated) {
//     const dashboardPath = userRole === "institute" ? "/institute-dashboard" : "/dashboard";
//     return <Navigate to={dashboardPath} replace />;
//   }

//   if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
//     return <NotFoundPage />;
//   }

//   const content = (
//     <AnimatedPageWrapper variant={isAuthRoute ? "auth" : "default"}>
//       {children}
//     </AnimatedPageWrapper>
//   );

//   return withMainLayout ? <MainLayout>{content}</MainLayout> : content;
// }


import { useLocation, Navigate } from "react-router-dom";
import { MainLayout } from "../../App";
import { AnimatedPageWrapper } from "./AnimatedPageWrapper";
import { LoadingScreen } from "../loading-screen";
import { useAuth } from "../../provider/useAuth";
import NotFoundPage from "../NotFoundPage";

const authPaths = ["/", "/login", "/register", "/forgot-password", "/password-reset/:token"];

export default function RouteWrapper({
  children,
  protectedRoute = false,
  publicRoute = false,
  withMainLayout = false,
  allowedRoles = [],
}) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const userRole = sessionStorage.getItem("role")?.toLowerCase();

  const isAuthRoute = authPaths.some((path) =>
    new RegExp("^" + path.replace(/:\w+/g, "[^/]+") + "$").test(location.pathname)
  );

  if (isLoading) {
    return <LoadingScreen />;
  }

  // Handle protected routes when not authenticated
  if (protectedRoute && !isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Handle public routes when authenticated
  if (publicRoute && isAuthenticated) {
    // const dashboardPath = userRole === "institute" ? "/institute-dashboard" : "/dashboard";
    const dashboardPath =
    userRole === "institute"
      ? "/institute-dashboard"
      : userRole === "teacher"
      ? "/teacher-dashboard"
      : "/dashboard";
    return <Navigate to={dashboardPath} replace />;
  }

  // Handle role-based access control
  if (allowedRoles.length > 0) {
    // If user is not authenticated, redirect to login
    if (!isAuthenticated) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    
    // If user is authenticated but doesn't have the required role, show 404
    if (!allowedRoles.includes(userRole)) {
      return withMainLayout ? (
          <NotFoundPage />
      ) : (
          <NotFoundPage />
      );
    }
  }

  const content = (
    <AnimatedPageWrapper variant={isAuthRoute ? "auth" : "default"}>
      {children}
    </AnimatedPageWrapper>
  );

  return withMainLayout ? <MainLayout>{content}</MainLayout> : content;
}